module.exports = __webpack_public_path__ + "assets/7620c30f188f5b8ec67a5319d180d753.svg";